export const simulateClickOn = (x: number, y: number, actionOnElement?: (e: Element) => void) => {
  const ev = new MouseEvent('click', { clientX: x, clientY: y, bubbles: false });
  const el = document.elementFromPoint(x, y);
  if (el !== null) {
    if (actionOnElement !== undefined) actionOnElement(el);
    el.dispatchEvent(ev);
  }
};
